module.exports = __webpack_public_path__ + "img/classify_5.9739575a.png";